module.exports = __webpack_public_path__ + "img/settings.40ebe297.svg";